// @core/api/endpoints/document/delete_document_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete policy
 * Deletes a document policy. Child policies that referenced this as parent_policy will fall through to the next ancestor.
 */
export async function DeleteDocumentPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
